
import {defineComponent} from "vue";
import Footer from "@/components/layout/footer.vue";
import Navbar from "@/components/layout/navbar.vue";

export default defineComponent({
  name: "App",
  components: {
    Navbar,
    Footer: Footer
  }
});
